import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CardProps {
  title?: string;
  subtitle?: string;
  icon?: ReactNode;
  badge?: ReactNode;
  children: ReactNode;
  variant?: 'solid' | 'outline' | 'frosted';
  className?: string;
}

export function Card({ 
  title, 
  subtitle, 
  icon, 
  badge, 
  children, 
  variant = 'solid',
  className = '' 
}: CardProps) {
  const baseClasses = 'rounded-3xl p-7 transition-all duration-300';
  const variantClasses = {
    solid: 'bg-white border-2 border-neutral-200 shadow-card hover:shadow-card-hover',
    outline: 'border-2 border-neutral-200 hover:border-brand-400 bg-white',
    frosted: 'bg-white/90 backdrop-blur-md border-2 border-white/30 shadow-soft hover:shadow-card',
  };

  return (
    <div className={cn(baseClasses, variantClasses[variant], className)}>
      {(icon || badge) && (
        <div className="flex items-start justify-between mb-5">
          {icon && <div className="text-brand-500">{icon}</div>}
          {badge && badge}
        </div>
      )}
      {title && <h3 className="text-xl font-black mb-3 text-neutral-900">{title}</h3>}
      {subtitle && <p className="text-neutral-700 mb-5 font-medium leading-relaxed">{subtitle}</p>}
      <div>{children}</div>
    </div>
  );
}

